<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div slot="header">
            <strong>Definições</strong>
          </div>
          <b-tabs>
            <b-tab title="Ranking">
              <div class="mb-3" >
                <h4>Quotas</h4>
                <b-row>
                  <b-col>
                    <b-form-fieldset label="Quota dentro do prazo">
                      <b-form-input type="number" name="fee_no_penalty" v-model="item.ranking.quotes.nopenalty" placeholder="Quota dentro do prazo" v-validate="{ required: true }" :state="validateState('fee_no_penalty')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('fee_no_penalty') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                  <b-col>
                    <b-form-fieldset label="Quota fora do prazo">
                      <b-form-input type="number" name="fee_penalty" v-model="item.ranking.quotes.penalty" placeholder="Quota fora do prazo" v-validate="{ required: true }" :state="validateState('fee_penalty')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('fee_penalty') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                </b-row>
              </div>
              <div class="mb-3">
                <h4>Antiguidade como sócio</h4>
                <b-row>
                  <b-col>
                    <b-form-fieldset label="Pontos por ano">
                      <b-form-input type="number" name="veteran_points" v-model="item.ranking.antiguity.points" placeholder="Pontos por ano" v-validate="{ required: true }" :state="validateState('veteran_points')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('veteran_points') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                  <b-col>
                    <b-form-fieldset label="Máximo">
                      <b-form-input type="number" name="antiguity_max" v-model="item.ranking.antiguity.max" placeholder="Máximo" v-validate="{ required: true }" :state="validateState('antiguity_max')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('antiguity_max') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                </b-row>
              </div>
              <div class="mb-3">
                <h4>Sócio</h4>
                <b-row>
                  <b-col>
                    <b-form-fieldset label="Sócio no ano anterior">
                      <b-form-input type="number" name="member_last_year" v-model="item.ranking.memberLastYear.yes" placeholder="Sócio no ano anterior" v-validate="{ required: true }" :state="validateState('member_last_year')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('member_last_year') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                  <b-col>
                    <b-form-fieldset label="Não sócio no ano anterior">
                      <b-form-input type="number" name="not_member_last_year" v-model="item.ranking.memberLastYear.no" placeholder="Não sócio no ano anterior" v-validate="{ required: true }" :state="validateState('not_member_last_year')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('not_member_last_year') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                </b-row>
              </div>
              <div class="mb-3">
                <h4>Fez Escalão em que se inscreve</h4>
                <b-row>
                  <b-col>
                    <b-form-fieldset label="Não Fez Escalão e é a última hipótese de fazer">
                      <b-form-input type="number" name="no_last_chance" v-model="item.ranking.isLastChance.yes"  v-validate="{ required: true }" :state="validateState('no_last_chance')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('no_last_chance') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                  <b-col>
                    <b-form-fieldset label="Não Fez Escalão mas ainda tem hipótese de fazer">
                      <b-form-input type="number" name="no_has_chance" v-model="item.ranking.isLastChance.no"  v-validate="{ required: true }" :state="validateState('no_has_chance')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('no_has_chance') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                  <b-col>
                    <b-form-fieldset label="Já Fez Escalão">
                      <b-form-input type="number" name="has_done" v-model="item.ranking.isLastChance.done"  v-validate="{ required: true }" :state="validateState('has_done')" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('has_done') }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                </b-row>
              </div>
              <div class="mb-3" >
                <h4>Participações nos campos</h4>
                <div class="mb-3" v-for="data in item.ranking.registrations" v-key="data.year">
                  <h5>Campo ano -{{ data.year }}</h5>
                  <b-row>
                    <b-col>
                      <b-form-fieldset label="Não teve lugar">
                        <b-form-input type="number" :name="'registration_'+data.year+'_no_slot'" v-model="data.noSlot" placeholder="Não teve lugar" v-validate="{ required: true }" :state="validateState('registration_'+data.year+'_no_slot')" data-vv-validate-on="change" ></b-form-input>
                        <b-form-invalid-feedback>
                          {{ errors.first('registration_'+data.year+'_no_slot') }}
                        </b-form-invalid-feedback>
                      </b-form-fieldset>
                    </b-col>
                    <b-col>
                      <b-form-fieldset label="Não se inscreveu">
                        <b-form-input type="number" :name="'registration_'+data.year+'_noRegistration'" v-model="data.noRegistration" placeholder="Não se inscreveu" v-validate="{ required: true }" :state="validateState('registration_'+data.year+'_noRegistration')" data-vv-validate-on="change" ></b-form-input>
                        <b-form-invalid-feedback>
                          {{ errors.first('registration_'+data.year+'_noRegistration') }}
                        </b-form-invalid-feedback>
                      </b-form-fieldset>
                    </b-col>
                    <b-col>
                      <b-form-fieldset label="Desistiu Válido">
                        <b-form-input type="number" :name="'registration_'+data.year+'_gaveUpOk'" v-model="data.gaveUpOk" placeholder="Desistiu Válido" v-validate="{ required: true }" :state="validateState('registration_'+data.year+'_gaveUpOk')" data-vv-validate-on="change" ></b-form-input>
                        <b-form-invalid-feedback>
                          {{ errors.first('registration_'+data.year+'_gaveUpOk') }}
                        </b-form-invalid-feedback>
                      </b-form-fieldset>
                    </b-col>
                    <b-col>
                      <b-form-fieldset label="Fez campo">
                        <b-form-input type="number" :name="'registration_'+data.year+'_participated'" v-model="data.participated" placeholder="Fez campo" v-validate="{ required: true }" :state="validateState('registration_'+data.year+'_participated')" data-vv-validate-on="change" ></b-form-input>
                        <b-form-invalid-feedback>
                          {{ errors.first('registration_'+data.year+'_participated') }}
                        </b-form-invalid-feedback>
                      </b-form-fieldset>
                    </b-col>
                    <b-col>
                      <b-form-fieldset label="Desistiu inválido">
                        <b-form-input type="number" :name="'registration_'+data.year+'_gaveUpInvalid'" v-model="data.gaveUpInvalid" placeholder="Desistiu inválido" v-validate="{ required: true }" :state="validateState('registration_'+data.year+'_gaveUpInvalid')" data-vv-validate-on="change" ></b-form-input>
                        <b-form-invalid-feedback>
                          {{ errors.first('registration_'+data.year+'_gaveUpInvalid') }}
                        </b-form-invalid-feedback>
                      </b-form-fieldset>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-tab>
            <b-tab title="Definições">
              <b-col>
                <b-form-fieldset label="Data a partir da qual as quotas são consideradas fora do prazo (AAAA-MM-DD)">
                  <b-form-input type="string" name="date_fees_late" v-model="item.settings.date_fees_late" placeholder="AAAA-MM-DD" v-validate="{ required: true }" :state="validateState('date_fees_late')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('date_fees_late') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
            </b-tab>
          </b-tabs>
          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:baseRoute + '.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!--/.col-->
      <div class="col-md-6">

      </div>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
export default {
  name: 'settingsEdit',
  props: ['id'],
  data() {
    return {
      url: 'settings',
      baseRoute: 'settings',
      showTeam: false,
      showPassword: false,
      countries: [],
      regions: [],
      item: {
        ranking: {
          quotes: {
            penalty: 0,
            nopenalty: 0
          },
          antiguity: {
            max: 0,
            points: 1
          },
          memberLastYear: {
            yes: 0,
            no: 0
          },
          isLastChance: {
            yes: 0,
            no: 0,
            done: 0
          },
          registrations: []
        }
      },
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      this.axios.put(this.url, data)
        .then(response => {
          this.item = response.data.data
          this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
          if (close) {
            this.$router.push({
              name: this.baseRoute + '.index'
            })
          }
        })
        .catch(response => {
          this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        })
    }
  },
  created() {
    var id = this.$route.params.id
    // for(let i=1; i<=8; i++) {
    //   this.item.ranking.registrations.push({
    //       year: i,
    //       noSlot: 0,
    //       noRegistration: 0,
    //       gaveUpOk: 0,
    //       participated: 0,
    //       gaveUpInvalid: 0
    //   })
    // }
    this.axios.get(this.url)
      .then(response => {
        this.item = response.data.data
        if(!this.item.ranking.isLastChance) {
          this.item.ranking.isLastChance = {yes: 0, no: 0, done: 0}
        }
      })
      .catch(response => {
        this.$bvToast.toast('Não foi possível carregar as definições', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.$router.push({
          name: this.baseRoute + '.index'
        })
      })
  }
}
</script>
